import {Form} from "../models/Form";

import {BasicStep} from "../models/steps/BasicStep";
import {ButtonStep} from "../models/steps/ButtonStep";
import {KeyboardStep} from "../models/steps/KeyboardStep";

import {Text} from "../models/fields/Text";
import {Textarea} from "../models/fields/Textarea";
import {Radio} from "../models/fields/Radio";
import {Select} from "../models/fields/Select";
import {Autocomplete} from "../models/fields/Autocomplete";
import {Button} from "../models/fields/Button";
import {Checkbox} from "../models/fields/Checkbox";
import {Datepicker} from "../models/fields/Datepicker";

import {MaskNumber} from "../models/fields/Features/mask/MaskNumber";
import {Mask} from "../models/fields/Features/mask/Mask";
import {MaskPattern} from "../models/fields/Features/mask/MaskPattern";

import {Option} from "../models/fields/Features/Option";

import store from '../store'

import ThanksRedirectStep from "../components/form/steps/library/fr/thanks_redirect/ThanksRedirectStep";
import HomeStep from "../components/form/steps/library/fr/desktop_home_no_scroll_link/HomeStepNoScrollLink";
import AddressStep from "../components/form/steps/library/fr/address/AddressStep";
import PhoneStep from "../components/form/steps/library/fr/phone/PhoneStep";
import IbanStep from "../components/form/steps/library/fr/lead_form_iban/IbanStep";
import SmsThanksStep from "../components/form/steps/library/fr/sms_thanks/SmsThanksStep";
import GenderStep from "../components/form/steps/library/fr/gender/GenderStep";
import NameStep from "../components/form/steps/library/fr/name/NameStep";
import EmailStep from "../components/form/steps/library/fr/email/EmailStep";
import PaymentOptinStep from "../components/form/steps/library/fr/payment_optin/PaymentOptinStep";
import PaymentChoiceStep from "../components/form/steps/library/fr/payment_choice/PaymentChoiceStep";
import CreditCardStep from "../components/form/steps/library/fr/credit_card/CreditCardStep";
import CreditCardRedirectStep from "../components/form/steps/library/fr/credit_card_redirect/CreditCardRedirectStep";
import ThanksStep from "../components/form/steps/library/fr/thanks_redirect/ThanksRedirectStep";

import MobileView from "../views/fr_lead_form/MobileView";
import RecapStep from "../components/form/steps/library/fr/recap/RecapStep";

let match_token = _.isEmpty(window.prospect) ? store.get('general_data/match_token') : window.prospect.match_token;
let gender = _.isEmpty(window.prospect) ? store.get('form_data/gender') : window.prospect.gender;
let lastname = _.isEmpty(window.prospect) ? store.get('form_data/lastname') : window.prospect.lastname;
let firstname = _.isEmpty(window.prospect) ? store.get('form_data/firstname') : window.prospect.firstname;
let email = _.isEmpty(window.prospect) ? store.get('form_data/email') : window.prospect.email;
let phone = _.isEmpty(window.prospect) ? store.get('form_data/phone') : window.prospect.phone;

console.log(gender, lastname, firstname, email, phone);
console.log(window.prospect);

let genderFieldToSend = match_token ? ['gender'] : [];
let nameFieldToSend = match_token ? ['lastname', 'firstname'] : [];

let guard = ['iban', 'payment_type', 'codice_fiscale', 'optin_iban', 'general_data/is_test'];
if (!_.get(window, 'prospect.phone')) {
    guard.push('phone')
}


let paymentOptinStep = new ButtonStep(PaymentOptinStep)
    .nextStep(() => {

        if (_.get(window, 'prospect.phone')) {
            store.set('func_data/lastname', store.get('form_data/lastname'))
            store.set('func_data/firstname', store.get('form_data/firstname'))
            store.set('func_data/match_token', store.get('general_data/match_token'))
            return 'thanks';
        }
        return 'phone';
    })
    .addFieldsToSend(['optin_iban']).enterAnimateDuration(.2)
    .leaveAnimateDuration(.2).hideProgress()

let firstStep = !_.isEmpty(window.prospect) ? 'recap' : 'gender'

let sms_service_status = window.sms_service_status==1 ? 'sms' : 'redirect_thanks';
export default new Form(MobileView)
    .firstStep('iban')
    .apiEndpoint('/prospect')
    .addSteps({
        iban: new BasicStep(IbanStep).hideProgress().nextStep('payment_optin').button('Poursuivre').disableBackButton()
            .guard(['iban', 'optin_iban', 'general_data/is_test'])
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                let prospect = store.get('form_data')
                let match_token = store.get('general_data/match_token');
                let query_string = location.search;

                let redirect_link = store.get('form/resource_form@redirect_link');

                if (!(
                    match_token &&
                    prospect.city &&
                    prospect.email &&
                    prospect.firstname &&
                    prospect.gender &&
                    prospect.lastname &&
                    prospect.phone &&
                    prospect.street &&
                    prospect.street_number &&
                    prospect.optin_terms_conditions &&
                    prospect.optin_privacy &&
                    prospect.zip_code)) {

                    if (redirect_link) {
                        window.location.href = redirect_link + query_string;
                    } else {
                        window.location.href = "/" + query_string;
                    }

                }

                if (!store.get('form_data/iban')) {
                    store.set('form_data/iban', 'BE')
                }
            })
            .addFieldsToSend(['iban']),
        payment_optin: new ButtonStep(PaymentOptinStep).disableBackButton()
            .nextStep(() => {
                store.set('func_data/lastname', store.get('form_data/lastname'))
                store.set('func_data/firstname', store.get('form_data/firstname'))
                store.set('func_data/match_token', store.get('general_data/match_token'))
                return 'thanks';
            })
            .addFieldsToSend(['optin_iban'])
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .hideProgress(),
        phone: new BasicStep(PhoneStep).nextStep('gender').disableBackButton()
            .button('Recevoir mon lien d\'activation')
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                store.set('general_data/is_dirty', true)
            }).beforeLeave(() => {
                let phone = store.get('form_data/phone')
                let form_id = store.get('form/resource_form@id')
                return axios.post('/phone', {phone, form_id})
            }),
        gender: new ButtonStep(GenderStep).nextStep('name').disableBackButton()
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        name: new BasicStep(NameStep).nextStep('email').disableBackButton()
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                store.set('form_data/optin_terms_conditions', 0)
                store.set('form_data/optin_privacy', 0)
            })
            .button('Continuer'),
        email: new BasicStep(EmailStep).nextStep('address').disableBackButton()
            .addFieldsToSend(['gender', 'firstname', 'lastname', 'email', 'optin_terms_conditions', 'optin_privacy', 'phone'])
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .button('Continuer'),
        address: new BasicStep(AddressStep).nextStep('iban').disableBackButton()
            .addFieldsToSend(['street', 'street_number', 'street_box_number', 'zip_code', 'city']).button('Continuer')
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                let phone = store.get('form_data/phone')
                let match_token = store.get('general_data/match_token')
                return axios.put('/phone', {
                    phone,
                    match_token
                })
            }),
        thanks: new BasicStep(ThanksRedirectStep).last().disableBackButton().hideProgress(),
    });


